exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".context-text {\n    position: relative;\n    background-color: white;\n    border-radius: 0 0 8px 8px;\n    padding: 1.5em 0.5em;\n    white-space: pre-line;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n}\n", ""]);
